var React = require('react');

function GridPatter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("pattern",{"id":"a","patternUnits":"userSpaceOnUse","width":"20","height":"20","patternTransform":"scale(2) rotate(0)"},[React.createElement("rect",{"x":"0","y":"0","width":"100%","height":"100%","fill":"hsla(0, 0%, 100%, 1)","key":0}),React.createElement("path",{"d":"M 10,-2.55e-7 V 20 Z M -1.1677362e-8,10 H 20 Z","strokeWidth":"1","stroke":"hsla(231, 48%, 48%, 1)","fill":"none","key":1})])),React.createElement("rect",{"width":"800%","height":"800%","transform":"translate(0,0)","fill":"url(%23a)","key":1})]);
}

GridPatter.defaultProps = {"id":"patternId","width":"100%","height":"100%"};

module.exports = GridPatter;

GridPatter.default = GridPatter;
